/**
 * Product-page performance charts (tables): same layout on every
 * /en/products/* and /es/productos/* detail route. Runs client-side (see pages/_app.js).
 */
export function annotateProductDetailTables(root = document) {
	if (typeof window === "undefined" || !root?.querySelectorAll) return;

	const tables = root.querySelectorAll(".tu-main--product-detail table");
	const columns = new Set();

	tables.forEach((table) => {
		addTableCaptionFromColspanHeader(table);
		wrapProductTable(table);
		table.dataset.tuMobileLayout = "scroll";
		table.dataset.tuMobileLabels = "done";
		table.classList.add("tu-product-chart");

		const column = table.closest(".col-md-9, .col-md-12, .filter-elements-first-col");
		if (column) columns.add(column);
	});

	columns.forEach(normalizeProductColumn);
}

function wrapProductTable(table) {
	if (table.closest(".tu-product-table-wrap")) return;

	const parent = table.parentElement;
	if (
		parent?.classList.contains("table-responsive") &&
		parent.children.length === 1 &&
		!parent.classList.contains("col-md-9") &&
		!parent.classList.contains("col-md-12")
	) {
		parent.classList.add("tu-product-table-wrap");
		return;
	}

	const wrap = document.createElement("div");
	wrap.className = "tu-product-table-wrap";
	table.parentNode.insertBefore(wrap, table);
	wrap.appendChild(table);
}

/** Bootstrap `table-responsive` on a whole column breaks chart layout — drop it after wrap. */
function normalizeProductColumn(column) {
	if (!column?.classList.contains("table-responsive")) return;
	column.classList.remove("table-responsive");
}

/** Moves colspan title row into a proper `<caption>` for accessibility. */
function addTableCaptionFromColspanHeader(table) {
	if (table.dataset.tuCaptionDone === "done") return;
	if (table.querySelector("caption")) {
		table.dataset.tuCaptionDone = "done";
		return;
	}

	const colspanTh = table.querySelector("thead tr th[colspan]");
	if (!colspanTh) return;

	const text = colspanTh.textContent.replace(/\s+/g, " ").trim();
	if (!text) return;

	const caption = document.createElement("caption");
	caption.className = [colspanTh.className, "caption-top"].filter(Boolean).join(" ");
	caption.textContent = text;
	table.insertBefore(caption, table.firstChild);
	colspanTh.closest("tr")?.remove();
	table.dataset.tuCaptionDone = "done";
}
